import React, { useState, useEffect } from 'react';
import NavBar from '../../components/navbar/navBarComponent';
import Breadcrumb from '../../components/breadcrumb/breadcrumbComponent';
import SurveyFeed from '../../components/survey-feed/surveyFeed'; // You need to create this component
import surveyUtils from '../../utils/survey';
import Search from '../../components/search/searchComponent';
import PageControls from '../../components/table-pagination/pageControls';
import config from '../../config/tableConfig';

const PAGE_SIZE = 10;

const SurveyListPage = (props) => {
  const [surveys, setSurveys] = useState(null);
  const [surveysVisible, setSurveysVisible] = useState(null);
  const [page, setPageNumber] = useState(1);
  const [isFiltered, setIsFiltered] = useState(null);
  const [searchStr, setSearchStr] = useState(null);

  const breadcrumbItems = [
    { name: 'Menu', link: '/menu' },
    { name: 'Surveys', link: '/surveys' }
  ];

  useEffect(() => {
    async function getSurveys() {
      const res = await surveyUtils.getAllSurveys();
      return res;
    }
    getSurveys().then((res) => {
      if (res.success) {
        setSurveys(res.data);
        const firstPageSurveys = res.data.slice(0, PAGE_SIZE);
        setSurveysVisible(firstPageSurveys);
      }
    });
  }, []);

  const generateSurveyList = (surveyListEnabled) => {
    const surveyList = [];
    if (surveyListEnabled) {
      for (let i = 0; i < surveyListEnabled.length; i++) {
        surveyList.push(
          <SurveyFeed
            key={surveyListEnabled[i]._id}
            surveyData={surveyListEnabled[i]}
          />
        );
      }
    }
    return surveyList;
  };

  const navigateNextPage = () => {
    const maxPage = Math.ceil(surveys.length / PAGE_SIZE);
    const nextPage = page + 1;
    if (nextPage <= maxPage) {
      const nextVisibleItems = surveys.slice(
        page * PAGE_SIZE,
        nextPage * PAGE_SIZE
      );
      setSurveysVisible(nextVisibleItems);
      setPageNumber(nextPage);
    }
  };

  const navigatePrevPage = () => {
    const prevPage = page - 1;
    if (prevPage >= 1) {
      const previousVisibleItems = surveys.slice(
        (prevPage - 1) * PAGE_SIZE,
        prevPage * PAGE_SIZE
      );
      setSurveysVisible(previousVisibleItems);
      setPageNumber(prevPage);
    }
  };

  const filterSurveys = (e) => {
    const filterStr = e.target.value.toLowerCase();
    setSearchStr(filterStr);
    const words = filterStr.split(' ');

    if (filterStr.length > 0) {
      let filteredSurveys = surveys;
      for (let i = 0; i < words.length; i++) {
        filteredSurveys = surveys.filter((el) => {
          return (
            el.title.toString().toLowerCase().includes(words[i]) ||
            el.description.toString().toLowerCase().includes(words[i]) ||
            (el.date &&
              new Date(el.date)
                .toLocaleDateString(config.locales.region)
                .includes(words[i]))
          );
        });
      }
      setSurveysVisible(filteredSurveys);
      setIsFiltered(true);
    } else {
      setSurveysVisible(surveys);
      setIsFiltered(false);
    }
  };

  return (
    <div id="main-survey-feed" className="container-fluid page">
      <NavBar cart={props.cart} isLogIn={props.isLogIn} />
      <Breadcrumb page="surveys-admin" items={breadcrumbItems} />
      <Search
        text="Buscar"
        placeholder="Buscar encuesta por Título o Fecha"
        searchCallback={filterSurveys}
        value={searchStr}
      />
      {generateSurveyList(surveysVisible)}
      <PageControls
        isFiltered={isFiltered}
        currentPage={page}
        nextPageHandler={navigateNextPage}
        prevPageHandler={navigatePrevPage}
        totalPages={surveys ? Math.ceil(surveys.length / PAGE_SIZE) : 0}
      />
    </div>
  );
};

export default SurveyListPage;